import React from 'react';
import crystalImage from '../assets/crystal.png';
import './crystal.css';

function Crystal({ size = 100, locked = false }) {
  return (
    <div style={{
      width: size,
      height: size * 1.3,
      opacity: locked ? 1 : 1,
      filter: locked ? 'grayscale(80%) brightness(0.8)' : 'drop-shadow(0 0 6px #6ee7ff)',
      transition: 'transform 0.3s ease',
      position: 'relative',
      transform: 'rotate(-35deg)' // adjust this angle until vertically aligned
    }}>
      <img
        src={crystalImage}
        alt={locked ? 'Locked crystal' : 'Unlocked crystal'}
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'contain',
          transform: 'rotate(5deg)' // counter the outer div rotation
        }}
      />
      {locked && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#fff',
          fontSize: '0.8rem',
          marginTop: '4px',
          textShadow: '0 0 4px black',
        }}>
          
        </div>
      )}
    </div>
  );
}

export default Crystal;